import { DEFAULT_OG_IMAGE } from '../data/site.mjs';
import {
    getCanonicalUrl,
    getPageConfig,
    PAGE_CONFIG_BY_ROUTE,
} from '../data/page-config.mjs';

/** @typedef {'organization' | 'website' | 'faqpage' | 'breadcrumb' | 'person'} SchemaId */

/**
 * @typedef {object} SeoEntry
 * @property {string} title
 * @property {string} description
 * @property {string} h1
 * @property {string} routePurpose
 * @property {string[]} truthClasses
 * @property {string} robots
 * @property {string} canonicalPath
 * @property {string} [image]
 * @property {SchemaId[]} schemas
 */

/** @type {Record<string, SeoEntry>} */
export const SEO_BY_ROUTE = Object.fromEntries(
    Object.entries(PAGE_CONFIG_BY_ROUTE).map(([path, config]) => [
        path,
        {
            title: config.title,
            description: config.description,
            h1: config.h1,
            routePurpose: config.routePurpose,
            truthClasses: config.truthClasses,
            robots: config.robots,
            canonicalPath: config.canonicalPath,
            image: config.image,
            schemas: config.schemas || [],
        },
    ])
);

export const PRERENDER_ROUTES = Object.keys(PAGE_CONFIG_BY_ROUTE);

/** Get the SEO entry for a given path, falling back to root. */
export function getSeo(path) {
    return SEO_BY_ROUTE[path] || SEO_BY_ROUTE['/'];
}

/** Build the canonical URL for a given path. */
export function getCanonical(path) {
    return getCanonicalUrl(path);
}

/** Get the robots directive for a given path. */
export function getRobots(path) {
    return getSeo(path).robots;
}

/** Get the OG image URL for a given path. */
export function getOgImage(path) {
    const entry = getPageConfig(path);
    return entry?.image || DEFAULT_OG_IMAGE;
}
